import { authOverride } from '@/utils/env';
import { getSession } from '@frontend/auth/ssr/session';
import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

export const getSessionFn = createServerFn().handler(async () => {
	const req = getRequest();

	const session = await getSession(req, authOverride);
	return { session, origin: new URL(req.url).origin };
});
